export class Transaction {
    constructor(originalTransactionId, transactionId, transactionTimestamp, environment, ownershipType, type, expirationTimestamp, transactionRevocationTimestamp, offerCode, promoOfferId) {
        this.originalTransactionId = originalTransactionId;
        this.transactionId = transactionId;
        this.transactionDate = new Date(transactionTimestamp);
        this.environment = environment;
        this.ownershipType = ownershipType;
        this.type = type;
        this.expirationDate = expirationTimestamp ? new Date(expirationTimestamp) : undefined;
        this.transactionRevocationDate = transactionRevocationTimestamp ? new Date(transactionRevocationTimestamp) : undefined;
        this.offerCode = offerCode;
        this.promoOfferId = promoOfferId;
    }
}
//# sourceMappingURL=Transaction.js.map